import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert, Spinner } from "react-bootstrap";
import emailjs from "emailjs-com";
import "../components/contacto.css";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import SocialBar from "../components/SocialBar";

const ContactoCumplimiento = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    correo: "",
    telefono: "",
    pregunta: "",
    area: "",
  });

  const [enviando, setEnviando] = useState(false);
  const [okMsg, setOkMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setOkMsg("");
    setErrMsg("");
    setEnviando(true);

    try {
      // Mapea a las variables de tu template EmailJS: {{name}}, {{email}}, {{title}}, {{message}}
      const templateParams = {
        name: formData.nombre,
        email: formData.correo,
        title: `Consulta Cumplimiento - ${formData.nombre}`,
        message:
          `Teléfono: ${formData.telefono}\n` +
          `Área: ${formData.area || "N/D"}\n\n` +
          `Pregunta:\n${formData.pregunta}`,
      };

      await emailjs.send(
        "service_dlspvi6",      // Service ID
        "template_yprli8r",     // Template ID
        templateParams,
        "Vy984JgaOGaAL2z9g"     // Public Key
      );

      setOkMsg("¡Gracias! Tu mensaje se envió correctamente. Te responderemos a la brevedad.");
      setFormData({
        nombre: "",
        correo: "",
        telefono: "",
        pregunta: "",
        area: "",
      });
    } catch (err) {
      console.error(err);
      setErrMsg("Ocurrió un error al enviar el mensaje. Intenta nuevamente en unos minutos.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div>
      <NavbarFacach />
      <Container className="contacto-form py-5">
        <h2 className="text-center mb-4">CUMPLIMIENTO | CONTÁCTENOS</h2>
        <p className="text-center mb-4">
          Ante cualquier consulta, puede ponerse en contacto con nosotros. Respondemos a la brevedad.
          <br />
          Complete los datos en los campos correspondientes.
        </p>

        {/* Dos columnas principales: izquierda formulario / derecha mapas */}
        <Row className="g-4 align-items-start">
          <Col xs={12} md={6} className="order-1 order-md-1">
            {okMsg && <Alert variant="success">{okMsg}</Alert>}
            {errMsg && <Alert variant="danger">{errMsg}</Alert>}

            <Form onSubmit={handleSubmit} noValidate>
              <Form.Group controlId="nombre" className="mb-3">
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  type="text"
                  name="nombre"
                  placeholder="Ingrese su nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Row className="g-3">
                <Col sm={12} md={6}>
                  <Form.Group controlId="correo" className="mb-3">
                    <Form.Label>Correo electrónico</Form.Label>
                    <Form.Control
                      type="email"
                      name="correo"
                      placeholder="correo@ejemplo.com"
                      value={formData.correo}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col sm={12} md={6}>
                  <Form.Group controlId="telefono" className="mb-3">
                    <Form.Label>Teléfono</Form.Label>
                    <Form.Control
                      type="tel"
                      name="telefono"
                      placeholder="9999-9999"
                      inputMode="tel"
                      pattern="\\d{4}-\\d{4}"  // necesario en JSX
                      value={formData.telefono}
                      onChange={handleChange}
                      required
                    />
                    <Form.Text>Formato: 9999-9999</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group controlId="pregunta" className="mb-3">
                <Form.Label>Su pregunta</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="pregunta"
                  placeholder="Escriba su consulta aquí..."
                  value={formData.pregunta}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              {/* Si usas 'área', habilítalo. Si no, puedes removerlo del estado */}
              {/* <Form.Group controlId="area" className="mb-3">
                <Form.Label>Área</Form.Label>
                <Form.Select name="area" value={formData.area} onChange={handleChange}>
                  <option value="">Seleccione un área</option>
                  <option value="DGRV">DGRV</option>
                </Form.Select>
              </Form.Group> */}

              <div className="text-start">
                <Button type="submit" variant="primary" disabled={enviando}>
                  {enviando ? (<><Spinner size="sm" className="me-2" /> Enviando...</>) : "Enviar"}
                </Button>
              </div>
            </Form>
          </Col>

          {/* Columna derecha: iframes (mapas) */}
          <Col xs={12} md={6} className="order-2 order-md-2 maps-col">
            <div className="mb-4">
              <h5 className="text-center">Nuestra sede en Tegucigalpa</h5>
              <div className="map-responsive">
                <iframe
                  title="Mapa Tegucigalpa"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d390.85413557973743!2d-87.19168653423334!3d14.100258881125505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f6fa2db4681560f%3A0xc87fc47edaf760e8!2sFACACH%20-%20Federaci%C3%B3n%20de%20Cooperativas%20de%20Ahorro%20y%20Cr%C3%A9dito%20de%20Honduras%20Ltda.%20Oficina%20Principal!5e1!3m2!1sen!2shn!4v1756930005344!5m2!1sen!2shn"
                  style={{ border: 0, width: "100%", height: "320px" }}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>

            <div>
              <h5 className="text-center">Nuestra sede en San Pedro Sula</h5>
              <div className="map-responsive">
                <iframe
                  title="Mapa San Pedro Sula"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3694.3190619864795!2d-88.02543682505714!3d15.51159228509003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f665b5d14d3d4e3%3A0xa691d1747237470f!2sFACACH!5e1!3m2!1sen!2shn!4v1756930061661!5m2!1sen!2shn"
                  style={{ border: 0, width: "100%", height: "320px" }}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </Col>
        </Row>

        <SocialBar position="right" top="35%" size={42} rounded={true} />
      </Container>

      <FooterFacach />
    </div>
  );
};

export default ContactoCumplimiento;
